const route = {
	name: 'search',
	path: '/nuestros-productos',
	component: () => import('@/pages/page-search'),
	props: true,
};
export default route;



// WEBPACK FOOTER //
// ./src/router/search.js